export const alertMixin = {
    data: function () {
        return {
            alertVisible: false,
            message: "",
            variant: ''
        }
    },

    methods: {
        showAlert: function (message, variant = 'danger') {
            this.variant = variant
            this.message = message
            this.alertVisible = true
        },
        alertShown: function () {
            this.alertVisible = false
        }
    }
}
